import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

export default function ForgotPassword() {
  const [email, setEmail]     = useState('');
  const [status, setStatus]   = useState('');
  const [error, setError]     = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setStatus('');
    setLoading(true);
    try {
      const res = await axios.post('/api/v1/forgot-password', { email });
      setStatus(res.data.message);
    } catch (err) {
      const msg = err.response?.data?.message || err.response?.data?.error || 'Something went wrong.';
      if (err.response?.status === 403) {
        setStatus(msg);
      } else {
        setError(msg);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.brand}>
          <div style={styles.logo}>Q</div>
          <div>
            <div style={styles.brandName}>Qlicxo</div>
            <div style={styles.brandTagline}>Digital Marketing Operations</div>
          </div>
        </div>

        <h2 style={styles.title}>Reset your password</h2>
        <p style={styles.subtitle}>
          Enter your owner email address and we'll send you a reset link.
        </p>

        {error  && <div style={styles.error}>{error}</div>}
        {status && <div style={styles.success}>{status}</div>}

        {!status && (
          <form onSubmit={handleSubmit}>
            <div style={styles.formGroup}>
              <label style={styles.label}>Email address</label>
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                style={styles.input}
                placeholder="you@agency.com"
                required
                autoFocus
              />
            </div>

            <button
              type="submit"
              style={loading ? { ...styles.button, opacity: 0.7 } : styles.button}
              disabled={loading}
            >
              {loading ? 'Sending...' : 'Send Reset Link'}
            </button>
          </form>
        )}

        <div style={styles.backLink}>
          <Link to="/login" style={styles.link}>← Back to login</Link>
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    background: '#0f1117',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
  },
  card: {
    background: '#1a1d27',
    borderRadius: '16px',
    padding: '40px',
    width: '100%',
    maxWidth: '420px',
    border: '1px solid #2a2d3e',
  },
  brand: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    marginBottom: '32px',
  },
  logo: {
    width: '44px',
    height: '44px',
    background: 'linear-gradient(135deg, #6c58f0, #4f8ef7)',
    borderRadius: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#fff',
    fontSize: '20px',
    fontWeight: '700',
  },
  brandName: {
    color: '#fff',
    fontSize: '18px',
    fontWeight: '700',
  },
  brandTagline: {
    color: '#6b7280',
    fontSize: '12px',
  },
  title: {
    color: '#fff',
    fontSize: '22px',
    fontWeight: '600',
    marginBottom: '8px',
  },
  subtitle: {
    color: '#6b7280',
    fontSize: '14px',
    marginBottom: '24px',
  },
  error: {
    background: '#2d1515',
    border: '1px solid #ef4444',
    color: '#ef4444',
    padding: '12px',
    borderRadius: '8px',
    marginBottom: '16px',
    fontSize: '14px',
  },
  success: {
    background: '#0f2d1a',
    border: '1px solid #22c55e',
    color: '#22c55e',
    padding: '12px',
    borderRadius: '8px',
    marginBottom: '16px',
    fontSize: '14px',
  },
  formGroup: {
    marginBottom: '16px',
  },
  label: {
    display: 'block',
    color: '#9ca3af',
    fontSize: '14px',
    marginBottom: '6px',
  },
  input: {
    width: '100%',
    padding: '12px',
    background: '#0f1117',
    border: '1px solid #2a2d3e',
    borderRadius: '8px',
    color: '#fff',
    fontSize: '14px',
    boxSizing: 'border-box',
    outline: 'none',
  },
  button: {
    width: '100%',
    padding: '12px',
    background: 'linear-gradient(135deg, #6c58f0, #4f8ef7)',
    border: 'none',
    borderRadius: '8px',
    color: '#fff',
    fontSize: '15px',
    fontWeight: '600',
    cursor: 'pointer',
    marginTop: '8px',
  },
  backLink: {
    textAlign: 'center',
    marginTop: '20px',
    fontSize: '14px',
  },
  link: {
    color: '#6c58f0',
    textDecoration: 'none',
    fontWeight: '500',
  },
};
